import { WorkTaskService } from "@common/client"
import { makeAxiosMutation, makeQuery } from "./utils"
import { workPackageKey, workPackagesKey } from "./work-packages"

export const workTasksBaseKey = ["work-tasks"] as const

export const workTaskKey = (id: string) => ["work-task", id] as const

export const workTasksForPackageKey = (
  params: Parameters<typeof WorkTaskService.getWorkTaskByWorkPackageId>[0],
) => [...workTasksBaseKey, "by-package", params] as const

export const workTasksForPackageQuery = makeQuery({
  serviceCall: WorkTaskService.getWorkTaskByWorkPackageId,
  queryKey: workTasksForPackageKey,
})

export const workTaskQuery = makeQuery({
  serviceCall: WorkTaskService.readItem,
  queryKey: (p) => workTaskKey(p.id),
})

export const useCreateWorkTaskMutation = makeAxiosMutation({
  serviceCall: WorkTaskService.createItem,
  invalidates: ({ workTaskCreate: { work_package_id } }) => [
    workTasksBaseKey,
    workPackagesKey,
    ...(work_package_id ? [workPackageKey(work_package_id)] : []),
  ],
})

type UpdateParams = Parameters<typeof WorkTaskService.updateItem>[0]

export const useUpdateWorkTaskMutation = makeAxiosMutation({
  serviceCall: ({
    work_package_id: _,
    ...params
  }: UpdateParams & { work_package_id: string }) =>
    WorkTaskService.updateItem(params),
  invalidates: (params) => [
    workTaskKey(params.id),
    workPackageKey(params.work_package_id),
  ],
})

type DeleteParams = Parameters<typeof WorkTaskService.deleteItems>[0]

export const useDeleteWorkTasksMutation = makeAxiosMutation({
  serviceCall: ({
    work_package_id: _,
    ...params
  }: DeleteParams & { work_package_id: string }) =>
    WorkTaskService.deleteItems(params),
  invalidates: (params) => [
    ...params.deleteWorkTasks.ids.map(workTaskKey),
    workPackageKey(params.work_package_id),
    workPackagesKey,
  ],
})

export const workTaskSearchKey = (params: {
  search?: string
  limit?: number
}) => [...workTasksBaseKey, "search", params.search, params.limit] as const

export const workTaskSearchQuery = makeQuery({
  serviceCall: WorkTaskService.readItems,
  queryKey: workTaskSearchKey,
})
